import React from 'react';
import PropTypes from 'prop-types';

import s from './index.module.css';

const DateSeparator = ({ timestamp }) => {
  const date = new Date(timestamp);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const isToday = date.toDateString() === today.toDateString();
  const isYesterday = date.toDateString() === yesterday.toDateString();
  const displayedDate = isToday ? 'Сегодня': isYesterday ? 'Вчера' : date.toLocaleDateString('ru-Ru', { day: 'numeric', month: 'long' });

  return (
    <div className={s.dateSeparator}>
      <span className={s.date}>
        {displayedDate}
      </span>
    </div>
  );
};

DateSeparator.propTypes = {
  timestamp: PropTypes.number.isRequired,
}

export default DateSeparator;
